import "pixi.js";

import ags from "ags/ags";
import { SetupAGSSettingsMenus } from "ags/commands/setup-ags-settings-menus";
import recoveryRecordBuilder from "ags/integration/builders/records/recovery-record-builder";
import spinRecordBuilder from "ags/integration/builders/records/spin-record-builder";
import pickRequestBuilder from "ags/integration/builders/requests/pick-request-builder";
import JackpotTriggertrailResultBuilder from "ags/integration/builders/results/jackpot-triggertrail-result-builder";
import pickTriggerResultBuilder from "ags/integration/builders/results/pick-trigger-result-builder";
import scatterResultBuilder from "ags/integration/builders/results/scatter-result-builder";
import agsForcer from "ags/integration/precan/ags-forcer";
import AGSFreespinsTriggeredHighlightWins from "ags/states/ags-freespins-triggered-highlight-wins";
import AGSRetriggerFreespins from "ags/states/ags-retrigger-freespins";
import OverAnimateThreshold from "ags/states/over-threshold";
import PickBonusState from "ags/states/pick-bonus-state";
import FreespinsBetbarToDefaultTransition from "ags/transitions/freespins-betbar-to-default-transition";
import gameiom from "gameiom/gameiom";
import gameiomModel from "gameiom/model/gameiom-model";
import { injectWrapper } from "gameiom/wrapper/lib/game-wrapper";
import wrapper from "gameiom/wrapper/wrapper-implementation";
import cgRecoveryBuilder from "integration/builders/records/cg-recovery-builder";
import gatewayResultBuilder from "integration/builders/result/gateway-result-builder";
import ReelSpinner from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import PaytableComponent, { PayoutMode } from "slotworks/components/paytable/paytable-component";
import GameLoop from "slotworks/core/game-loop";
import DebugMenu from "slotworks/debug/menu/debug-menu";
import ForceTab from "slotworks/debug/menu/tabs/force-tab";
import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import ButtonElement from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import particleManager from "slotworks/graphics/particles/particle-manager";
import builderManager from "slotworks/server/builders/builder-manager";
import SlotWorks from "slotworks/slotworks";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import FreespinsTriggered from "slotworks/state-machine/standard/decisions/freespins-triggered";
import IsBonusTriggered from "slotworks/state-machine/standard/decisions/is-bonus-triggered";
import RecoverFreespinsMode from "slotworks/state-machine/standard/states/recover-freespins-mode";
import Spin from "slotworks/state-machine/standard/states/spin";
import SymbolCelebration from "slotworks/state-machine/standard/states/symbol-celebration";
import { default as StateMachine, default as stateMachine } from "slotworks/state-machine/state-machine";
import StateRegister from "slotworks/state-machine/state-register";
import FadeTransition from "slotworks/transitions/fade-transition";
import { EnableOnScreenErrors } from "slotworks/utils/debug";
import DeviceInfo from "slotworks/utils/device-info";
import Logger from "slotworks/utils/logger";
import { SymbolStaticPool } from "slotworks/utils/symbol-static-pool";
import CGIsFreespinsGateway from "state-machine/decisions/cg-is-freespin-gateway";
import CGIsGateway from "state-machine/decisions/cg-is-gateway";
import IsPickComplete from "state-machine/decisions/cg-is-pick-complete";
import CGEnterFreespins from "state-machine/states/cg-enter-freespins";
import CGGatewayBonus from "state-machine/states/cg-gateway-bonus";
import CGIdle from "state-machine/states/cg-idle";
import CGInit from "state-machine/states/ll-init";
import { CGMCBonusEnter } from "state-machine/states/cg-mc-bonus-enter";
import { CGMCBonusExit } from "state-machine/states/cg-mc-bonus-exit";
import CGMCBonusRequestSpin from "state-machine/states/cg-mc-bonus-request-spin";
import { CGMCBonusSpin } from "state-machine/states/cg-mc-bonus-spin";
import { CGRecoverFreespins } from "state-machine/states/cg-recover-freespins";
import { CGRequestSpin } from "state-machine/states/cg-request-spin";
import { CGSpin } from "state-machine/states/cg-spin";
import { MultiReelSpin } from "state-machine/states/multi-reel-spin";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import mcSpinRecordBuilder from "./integration/builders/records/mc-spin-record-builder";
import substituteSymbols from "utils/substitute-symbols";
import CGExitFreespins from "state-machine/states/cg-exit-freespins";
import CGLoopWins from "state-machine/states/cg-loop-wins";
import CGMenucontentPaytableTransition from "transitions/cg-menucontent-paytable-transition";
import authRecordBuilder from "ags/integration/builders/records/auth-record-builder";
import cgAuthRecordBuilder from "integration/builders/records/cg-auth-record-builder";
import CGGameiomRequestFreespin from "state-machine/states/cg-gameiom-request-freespin";
import CGHighlightWins from "state-machine/states/cg-highlight-wins";
import CGIsRecoveryPick from "state-machine/decisions/cg-is-recovery-pick";
import CGRecoverMatrix from "state-machine/states/cg-recover-matrix";
import ZoomSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/zoom-symbol-behaviour";
import agsPickForcer from "ags/integration/precan/ags-pick-forcer";
import Mediators from "ags/mediators/mediators";
import BigBorderLoopWinsMediator from "ags/mediators/big-border-loop-wins-mediator";
import lineResultBuilder from "ags/integration/builders/results/line-result-builder";
import llLineResultBuilder from "integration/builders/result/ll-line-result-builder";
import llBonusScatterSubstituteSupplement from "integration/supplements/ll-bonus-scatter-substitute-supplement";
import Gameplay from "slotworks/model/gameplay/gameplay";
import { CMScatterSymbolResultBuilder } from "ags/integration/builders/results/hold-and-spin-scatter-result-builder";
import symbolSubstituteSupplement from "slotworks/model/gameplay/supplements/symbol-substitute-supplement";
import CGRollUp from "state-machine/states/cg-roll-up";
import LLIsRecoveryFreespins from "state-machine/decisions/ll-is-recovery-freespins";
import llBonusWildSubstituteSuppement from "integration/supplements/ll-bonus-wild-substitute-suppement";
import llWildBonusResultBuilder from "integration/builders/result/ll-wild-bonus-result-builder";
import LLIsWildFortuneBlast from "state-machine/decisions/ll-is-wild-fortune-blast";
import LLFortuneBlastWildCelebration from "state-machine/states/ll-fortune-blast-wild-celebration";
import Components from "slotworks/components/components";
import SymbolFooter from "slotworks/components/footer/symbol-footer-component";
import BigBorderIgnoreWildWindMediator from "mediators/big-border-ignore-wild-win-mediator";
import { CGMCBonusWildEnter } from "state-machine/states/cg-mc-bonus-wild-enter";
import llHoldAndSpinRecordBuilder from "integration/builders/records/ll-hold-and-spin-record-builder";
import CGGatewayCelebration from "state-machine/states/cg-gateway-celebration";
import LLRetriggerFreespins from "state-machine/states/ll-retrigger-freespins";

declare const __ENVIRONMENT__: string;
declare const __DEBUG__: boolean;
declare const require: any;
const assetConfig = require("./asset-config.json");
const gameConfig = require("./game-config.json");
const stateConfig = require("./state-config.json");
const soundConfig = require("./sound-config.json");
const componentConfig = require("./component-config.json");
const i18nConfig = require("./i18n-config.json");

/////////////////
////////////////
/////////////////////////
 
//////////

injectWrapper();

const configure = () => {
    CanvasManager.setPortraitCanvasEnabled(!DeviceInfo.isDesktop);
    CanvasManager.setPortraitEnabled(!DeviceInfo.isDesktop);

    wrapper.init(__DEBUG__);

    ButtonElement.DISABLED_TINT = 0xA9A9A9;
    ButtonElement.OVER_TINT = 0xd3d3d3;
    ButtonElement.DOWN_SCALE = 0.95;
    RecoverFreespinsMode.SET_WINNINGS_TO_TOTAL_WIN = true;

    particleManager.autoCap = false;

    Spin.ENABLE_SAFETY_CHECK = false;

    Mediators.LoopWinsMediatorType = BigBorderIgnoreWildWindMediator;

    SymbolFooter.SYMBOL_SIZE = 33;
    SymbolFooter.SYMBOL_PADDING = 0.13;
    SymbolFooter.PORTRAIT_SCALE = 1.3;
    Components.FooterComponentType = SymbolFooter;

    ZoomSymbolBehaviour.ZOOM_TO = .7;
    ZoomSymbolBehaviour.ANIMATION_DURATION = 500;
    ZoomSymbolBehaviour.PAUSE_DURATION = 0;
};

const setupComms = () => {
    ags.setupLinesGame();

    builderManager.addRequestBuilder(pickRequestBuilder);
    builderManager.removeRecordBuilder(spinRecordBuilder);
    builderManager.addRecordBuilder(mcSpinRecordBuilder);
    builderManager.addRecordBuilder(llHoldAndSpinRecordBuilder);

    builderManager.removeRecordBuilder(authRecordBuilder);
    builderManager.addRecordBuilder(cgAuthRecordBuilder);

    builderManager.removeResultBuilder(scatterResultBuilder);
    builderManager.addResultBuilder(llWildBonusResultBuilder);
    builderManager.addResultBuilder(gatewayResultBuilder);
    builderManager.addResultBuilder(JackpotTriggertrailResultBuilder);

    builderManager.removeRecordBuilder(recoveryRecordBuilder);
    builderManager.addRecordBuilder(cgRecoveryBuilder);

    builderManager.addResultBuilder(pickTriggerResultBuilder);
    builderManager.removeResultBuilder(lineResultBuilder);
    builderManager.addResultBuilder(llLineResultBuilder);

    Gameplay.dataProcessorSupplements.addBeforeStandard(llBonusScatterSubstituteSupplement);
    Gameplay.dataProcessorSupplements.addBeforeStandard(symbolSubstituteSupplement);
    Gameplay.dataProcessorSupplements.addBeforeStandard(llBonusWildSubstituteSuppement);
    CMScatterSymbolResultBuilder.scatterSymbolId = 12;
};

const setupStates = () => {
    // Luck and Luxury
    StateRegister.add("cg-init", new CGInit(StateMachine));
    StateRegister.add("cg-spin", new CGSpin(StateMachine));
    StateRegister.add("cg-idle", new CGIdle(StateMachine));
    StateRegister.add("cg-request-spin", new CGRequestSpin(StateMachine));
    StateRegister.add("cg-multireel-spin", new MultiReelSpin(StateMachine));
    StateRegister.add("cg-enter-freespins", new CGEnterFreespins(StateMachine));
    StateRegister.add("cg-exit-freespins", new CGExitFreespins(StateMachine));
    StateRegister.add("cg-recover-freespins", new CGRecoverFreespins(StateMachine));
    StateRegister.add("cg-recover-matrix", new CGRecoverMatrix(StateMachine));

    StateRegister.add("cg-mc-bonus-wild-enter", new CGMCBonusWildEnter(StateMachine));
    StateRegister.add("cg-mc-bonus-enter", new CGMCBonusEnter(StateMachine));
    StateRegister.add("cg-mc-bonus-request-spin", new CGMCBonusRequestSpin(StateMachine));
    StateRegister.add("cg-mc-bonus-spin", new CGMCBonusSpin(StateMachine));
    StateRegister.add("cg-mc-bonus-exit", new CGMCBonusExit(StateMachine));

    // Vault / Gateway bonus.
    StateRegister.add("cg-is-freespin-gateway", new CGIsFreespinsGateway());
    StateRegister.add("cg-is-gateway-bonus", new CGIsGateway());
    StateRegister.add("cg-gateway-bonus", new CGGatewayBonus(StateMachine));

    // Pick Bonus
    StateRegister.add("is-mc-bonus", new IsBonusTriggered("pick"));
    StateRegister.add("bonus-state", new PickBonusState(stateMachine));
    StateRegister.add("is-mc-bonus-complete", new IsPickComplete());
    StateRegister.add("is-bonus-wild-fortune-blast", new LLIsWildFortuneBlast());
    StateRegister.add("ll-fortune-blast-wild-celebration", new LLFortuneBlastWildCelebration(stateMachine));

    // Free spins
    StateRegister.add("freespin-triggered-check", new FreespinsTriggered());
    StateRegister.add("freespins-triggered-highlight-wins", new AGSFreespinsTriggeredHighlightWins(StateMachine));
    StateRegister.add("freespin-retrigger-celebration", new SymbolCelebration(StateMachine, "BN"));
    StateRegister.add("freespins-retriggered-celebration", new LLRetriggerFreespins(StateMachine));
    StateRegister.add("ags-retrigger-freespins", new AGSRetriggerFreespins(StateMachine));
    StateRegister.add("cg-gameiom-request-freespin", new CGGameiomRequestFreespin(StateMachine));
    StateRegister.add("cg-highlight-wins", new CGHighlightWins(StateMachine));
    StateRegister.add("freespins-triggered-celebration", new CGGatewayCelebration(StateMachine));

    // Recovery
    StateRegister.add("cg-is-recovery-pick", new CGIsRecoveryPick());
    StateRegister.add("ll-is-recovery-freespins", new LLIsRecoveryFreespins());

    // General
    StateRegister.add("cg-roll-up", new CGRollUp(StateMachine));
    StateRegister.add("cg-loop-wins", new CGLoopWins(StateMachine));
    StateRegister.add("is-over-highlight-threshold", new OverAnimateThreshold());
};

const setupTransitions = () => {

    Layers.Prompts.setTransitions("freespinswin", new FadeTransition(Layers.Prompts, 400));
    Layers.Prompts.setTransitions("fortune_blast_won", new FadeTransition(Layers.Prompts, 400));
    Layers.Prompts.setTransitions("fortune_blast_wild", new FadeTransition(Layers.Prompts, 400));

    Layers.MenusContent.setTransitions("paytable_rb", new CGMenucontentPaytableTransition());

    if (Layers.BetBar.hasScene("freespins")) {
        Layers.BetBar.setTransitions("freespins", new FreespinsBetbarToDefaultTransition(), "default");
    }
};

const setupComponents = () => {
    ReelSpinner.extended = true;
    PaytableComponent.payoutMode = PayoutMode.MULTIPLIER_ONLY;
    SymbolStaticPool.NUMBER_OF_SYMBOLS = 60;
};

const setupForces = () => {
    const results = new Map<string, string>();
    results.set("FB Gateway", "gateway-mc");
    results.set("FS Gateway", "gateway-fs");
    results.set("FB Wild", "wilds-mc");
    results.set("FB no jackpot", "mc-nojackpot");
    results.set("FB Wild with FB Gateway", "gateway-mc-with-mc");
    results.set("FB Wild with FS Gateway", "gateway-fs-with-mc");
    results.set("FB Gateway with regular win", "gateway-mc-regular-win");
    results.set("FB Wild with regular win", "wilds-mc-regular-win");
    results.set("Big Win", "big-win");
    results.set("Mega Win", "huge-win");
    results.set("Tiny Win", "20,20,20,20,20");
    results.set("4 BN Symbols", "6,50,4,9,34");
    results.set("clearRecovery", "clearRecovery");

    const pickResults = new Map<string, string>();
    pickResults.set("Mini", "mini");
    pickResults.set("Minor", "minor");
    pickResults.set("Major", "major");
    pickResults.set("Grand", "grand");

    agsPickForcer.setResults(pickResults);
    agsForcer.setResults(results);

    DebugMenu.add(new ForceTab("Force Pick", agsPickForcer));
    DebugMenu.add(new ForceTab("AGS", agsForcer));
};

const ready = () => {
    setupTransitions();
    SetupAGSSettingsMenus();

///////////////////////////////////////////////////
/////////////////////////////////////////////////////
/////////////////////////////
/////
//////////////

    if (gameiomModel.enableForcing) {
        setupForces();
    }

    // const integrationDebugger = new IntegrationDebugger();
    // integrationDebugger.start();

    const paytableGroup = SmartUIManager.newSmartUIGroup(Layers.MenusContent, "paytable_rb");
    SmartUIManager.registerButtonToGroup("information", Layers.BetBar, ["default", "freespins", "default_currency", "freespins_currency"], paytableGroup);
    SmartUIManager.registerButtonToGroup("help", Layers.MenusContent, ["general"], paytableGroup);

    paytableGroup.setFlagsOnShow([SmartUIFlag.MENU]);
    paytableGroup.addDisableCondition([SmartUIFlag.FREE_SPINS]);
    paytableGroup.addDisableCondition([SmartUIFlag.PROMPT]);
    SmartUIManager.addAutoHideGroupCondition(paytableGroup, [], [SmartUIFlag.IDLE]);
};

configure();
setupComponents();
setupComms();
setupStates();

gameiom.init().then(() => {
    gameiom.setProviderId(48);

/////////////////////
//////////////////////////////////////
//////////////////

        SlotWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, ready);

        substituteSymbols.addDarkSymbolDefinitions();
        bonusSymbolSetup.setupDefinitions();

        gameiom.initWrapper();
/////////////////////////
///////
//////////////
});

///////////////////////////////////////////////
/////////////////////////////////////////////////
///////////////////////////
 
//////////
